import React from 'react';
export const MultiSelectContext = React.createContext({
    selectedValues: []
});
//# sourceMappingURL=MultiSelectContext.js.map